<template>
  <div v-if="loaded">
    <el-dialog
      :visible.sync="selfShow"
      width="1380px"
      :title="popupTitle"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-tabs :list="this.$constant.tabListZhiZao()" :activeVal.sync="tabActive" />
        <div class="box-y-scroll" :style="{ 'max-height': maxHeight }">
          <div v-show="tabActive === '0'">
            <Table1
              v-if="selfData.table_1.length"
              :list="selfData.table_1"
              :isOut="selfData.formData.ding_dan_lei_xing === '来料加工订单'"
            />
            <Table2 v-if="selfData.table_2.length && false" :list="selfData.table_2" />
            <Table3 v-if="selfData.table_3.length" :list="selfData.table_3" />
            <Table4 v-if="selfData.table_4.length" :list="selfData.table_4" />
          </div>

          <Table0 v-show="tabActive === '1'" ref="refTableData0" :list="selfData.table_0" />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table1 from './table-1'
import Table2 from './table-2'
import Table3 from './table-3'
import Table4 from './table-4'
import Table0 from './table-0'
export default {
  components: {
    Table1,
    Table2,
    Table3,
    Table4,
    Table0
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    isVerify: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selfShow: false,
      loaded: false,
      tabActive: '0',
      selfData: {}
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 360}px`
      return result
    },
    popupTitle() {
      let code = this.selfData.formData.bill_code
      let type = this.selfData.formData.ding_dan_lei_xing
      let result = `制造明细(${code})`
      if (type) result += `-${type}`
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      let url = '/admin/gcvip/checkBill2/zhizaoDetail'
      if (!this.isVerify) url = '/admin/gcvip/gongChengXieTong3/zhizaoDetail'
      await this.$api({
        method: 'get',
        url,
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          let table_1 = result.table_1.filter((item) => !item.has_bom)
          result.table_1 = this.$util.deepCopy(table_1)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .vxe-grid .vxe-grid--table-wrapper {
    overflow: visible !important;
  }
  /deep/ .vxe-table--body-wrapper {
    overflow: visible !important;
  }
}
</style>
